import GoogleMapsLoader from 'google-maps/lib/Google';
GoogleMapsLoader.KEY = 'AIzaSyALjjdYcXlXZV27wDxS8bOLukhfiIdRU8w';

export default function() {

    GoogleMapsLoader.load((google) => {

        function new_map( $el ) {
            // var
            var $markers = $el.find('.marker');

            // vars
            var args = {
                zoom		: 16,
                center		: new google.maps.LatLng(0, 0),
                mapTypeId	: google.maps.MapTypeId.ROADMAP,
                styles: [{ "stylers": [{ "saturation": -100 }]}],
            }

            // create map
            var map = new google.maps.Map( $el[0], args);

            // add a markers reference
            map.markers = [];

            // add markers
            $markers.each(function(){
                add_marker($(this), map);
            });

            // center map
            center_map( map );


            // return
            return map;

        }

        function add_marker( $marker, map ) {

            // var
            var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

            // create marker
            var marker = new google.maps.Marker({
                position	: latlng,
                map			: map,
                icon        : $marker.data('icon'),
            })

            // add to array
            map.markers.push( marker );

            // if marker contains HTML, add it to an infoWindow
            //if( $marker.html() )
            //{
                // create info window
                //var infowindow = new google.maps.InfoWindow({
                 //   content		: $marker.html(),
                //});

                // show info window when marker is clicked
                //google.maps.event.addListener(marker, 'click', function() {
                   // infowindow.open( map, marker );
                //});
            //}

        }

        function center_map( map ) {

            // vars
            var bounds = new google.maps.LatLngBounds();

            // loop through all markers and create bounds
            $.each( map.markers, function( i, marker ){

                var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

                bounds.extend( latlng );

            });

            // only 1 marker?
            if( map.markers.length == 1 )
            {
                // set center of map
                map.setCenter( bounds.getCenter() );
                map.setZoom( 16 );
            }
            else
            {
                // fit to bounds
                map.fitBounds( bounds );
            }

        }

        $('.acf-map').each(function(){

            // create map
            new_map( $(this) );

        });


    });

}



// WEBPACK FOOTER //
// ./scripts/app/map.js